import { render, staticRenderFns } from "./FormModelEmbed.vue?vue&type=template&id=24917fe6&"
import script from "./FormModelEmbed.vue?vue&type=script&lang=ts&"
export * from "./FormModelEmbed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports